import { render, staticRenderFns } from "./AddTable.vue?vue&type=template&id=a4c5715c&scoped=true"
import script from "./AddTable.vue?vue&type=script&lang=js"
export * from "./AddTable.vue?vue&type=script&lang=js"
import style0 from "./AddTable.vue?vue&type=style&index=0&id=a4c5715c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4c5715c",
  null
  
)

export default component.exports